import React from 'react';

import ReportsDropdown from '../../ReportsDropdown';
import SharedTools from '../../../SharedTools';


const HeaderOrgEmailDeleteActivity = () => (
    <div className="HeaderOrgEmailDeleteActivity">
        <header>
            <div className="title-label">
                <i className="fa-solid fa-trash sp-margin5" alt="Delete icon"></i> Delete Organization Email Activity
            </div>
            <aside className="mid-header-bar spacer-inline">
                <ReportsDropdown />
                <button className="btn btn-outline-dark sp-margin5 btn-reports-sm" data-target="#deleteActivitySearchModal" data-toggle="modal" title="Search" alt="search for delete activities">
                    <i className="bi bi-search" alt="search icon"></i>
                </button>
                <button className="btn btn-outline-dark sp-margin5 btn-reports-sm" data-target="#deleteActivityBulkModal" data-toggle="modal" title="Bulk Download">
                    <i className="bi bi-box-arrow-down" alt="bulk download icon"></i>
                </button>
                <SharedTools />
            </aside>
        </header>
  </div>
);

HeaderOrgEmailDeleteActivity.propTypes = {};

HeaderOrgEmailDeleteActivity.defaultProps = {};

export default HeaderOrgEmailDeleteActivity;
